import type { AvatarDetails } from '~/types/avatar'
import type { EmoteDetails } from '~/types/emote'
import { ENV_CONFIG } from '../../config/environment'

const API_BASE_URL = ENV_CONFIG.apiBaseUrl || 'https://localhost:3001'

/**
 * アプリケーション設定のレスポンス型
 */
export interface AppConfig {
  defaultAvatar: AvatarDetails
  /** デフォルト（システム）エモート。全ユーザー・ゲストが再生可能（backend #490） */
  defaultEmotes: EmoteDetails[]
}

/**
 * アプリケーション設定を取得
 * 認証不要のパブリックAPI
 * Cache-Control: public, max-age=300 でキャッシュされる
 */
export async function getConfig(): Promise<AppConfig> {
  const response = await fetch(`${API_BASE_URL}/api/config`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.status} ${response.statusText}`)
  }

  const data = await response.json()

  // createdAtをDate型に変換
  return {
    ...data,
    defaultAvatar: {
      ...data.defaultAvatar,
      createdAt: new Date(data.defaultAvatar.createdAt),
    },
    // バックエンド未対応（backend #490 デプロイ前）の場合は空配列
    defaultEmotes: data.defaultEmotes ?? [],
  }
}
